// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"83b8e182","618":"8709e14d"}[chunkId] + ".chunk.css";
};